export function truncate(text: string): string {
    let newString = text;
    if (text.length > 20) {
        newString = `${text.substring(0, 19)}...`
    }
    return newString;
}